export default "__VITE_ASSET__YRaExQkF__"